"use client";

import { useQuery } from "@tanstack/react-query";
import { useAccessToken } from "@/hooks";
import { QueryKeys } from "@/lib/types";
import {
  getPrivateLessonEntriesFromApi,
  type PrivateLessonsFilters,
} from "@/lib/services/privateLessonsService";

export function usePrivateLessonsCalendar(
  filters: PrivateLessonsFilters,
  options?: { enabled?: boolean }
) {
  const accessToken = useAccessToken();
  const enabled = options?.enabled !== false && !!accessToken;

  return useQuery({
    queryKey: [QueryKeys.PrivateLessonsCalendar, filters],
    queryFn: () => getPrivateLessonEntriesFromApi(accessToken!, filters),
    enabled,
    staleTime: 2 * 60 * 1000,
  });
}
